<!--
 * @Description: 教职工 详情
 * @Author: PF
 * @Date: 2023-03-08 10:33:25.239
 * @LastEditors: PF
 * @LastEditTime: 2025-12-22 14:59:04
-->
<template>
  <div>
    <el-row :gutter="20" shadow="never">
      <el-col :span="20">
        <el-descriptions :column="4" border >
          <el-descriptions-item label="工号" label-align="right" align="left" width="150px" span="2">{{ruleForm.gh}}</el-descriptions-item>
          <el-descriptions-item label="姓名" label-align="right" align="left" width="134px" span="2">{{ruleForm.xm}}</el-descriptions-item>
          <el-descriptions-item label="英文姓名" label-align="right" align="left" span="2">{{ruleForm.ywxm}}</el-descriptions-item>
          <el-descriptions-item label="姓名拼音" label-align="right" align="left" span="2">{{ruleForm.xmpy}}</el-descriptions-item>
          <el-descriptions-item label="曾用名" label-align="right" align="left" span="2">{{ruleForm.cym}}</el-descriptions-item>
          <el-descriptions-item label="身份证件类型" label-align="right" align="left" span="2">{{ruleForm.sfzjlxmc}}</el-descriptions-item>
          <el-descriptions-item label="身份证件号 " label-align="right" align="left" span="2">{{ruleForm.sfzjh}}</el-descriptions-item>
          <el-descriptions-item label="出生日期" label-align="right" align="left" span="2">{{ruleForm.csrq}}</el-descriptions-item>
          <el-descriptions-item label="性别" label-align="right" align="left" span="2">{{ruleForm.xb}}</el-descriptions-item>
          <el-descriptions-item label="民族" label-align="right" align="left" span="2">{{ruleForm.mzbt}}</el-descriptions-item>
          <el-descriptions-item label="血型" label-align="right" align="left" span="2">{{ruleForm.xxbt}}</el-descriptions-item>
          <el-descriptions-item label="健康状况" label-align="right" align="left" span="2">{{ruleForm.jkzkbt}}</el-descriptions-item>
          <el-descriptions-item label="婚姻状态" label-align="right" align="left" span="2">{{ruleForm.hyztbt}}</el-descriptions-item>
          <el-descriptions-item label="政治面貌" label-align="right" align="left" span="2">{{ruleForm.zzmmbt}}</el-descriptions-item>
          <el-descriptions-item label="港澳台侨外" label-align="right" align="left" span="2">{{ruleForm.gatqwbt}}</el-descriptions-item>
          <el-descriptions-item label="籍贯" label-align="right" align="left" span="2">{{ruleForm.jg}}</el-descriptions-item>
          <el-descriptions-item label="国籍/地区" label-align="right" align="left" span="2">{{ruleForm.gjdqbt}}</el-descriptions-item>
          <el-descriptions-item label="信仰宗教" label-align="right" align="left" span="2">{{ruleForm.xyzjbt}}</el-descriptions-item>
          <el-descriptions-item label="出生地行政区划" label-align="right" align="left" span="4">{{ruleForm.csdmc}}</el-descriptions-item>
          <el-descriptions-item label="户口所在地行政区划" label-align="right" align="left" span="4">{{ruleForm.hkszdmc}}</el-descriptions-item>
          <el-descriptions-item label="户口类别" label-align="right" align="left" span="2">{{ruleForm.hklbbt}}</el-descriptions-item>
          <el-descriptions-item label="当前住址 " label-align="right" align="left" span="2">{{ruleForm.dqzz}}</el-descriptions-item>
          <el-descriptions-item label="当前住址邮政" label-align="right" align="left" span="2">{{ruleForm.dqzzyzbm}}</el-descriptions-item>
          <el-descriptions-item label="参加工作年月" label-align="right" align="left" span="2">{{ruleForm.cjgzny}}</el-descriptions-item>
          <el-descriptions-item label="从教年月" label-align="right" align="left" span="2">{{ruleForm.cjny}}</el-descriptions-item>
          <el-descriptions-item label="来校年月" label-align="right" align="left" span="2">{{ruleForm.lxny}}</el-descriptions-item>
          <el-descriptions-item label="编制类别" label-align="right" align="left" span="2">{{ruleForm.bzlbbt}}</el-descriptions-item>
          <el-descriptions-item label="教职工类别" label-align="right" align="left" span="2">{{ruleForm.jzglbbt}}</el-descriptions-item>
          <el-descriptions-item label="岗位类别" label-align="right" align="left" span="2">{{ruleForm.gwlbbt}}</el-descriptions-item>
          <el-descriptions-item label="否兼职教师" label-align="right" align="left" span="2">
            <span v-if="ruleForm.sfjzjs === true">是</span>
            <span v-if="ruleForm.sfjzjs === false">否</span>
          </el-descriptions-item>
          <el-descriptions-item label="是否双师型教师" label-align="right" align="left" span="2">
            <span v-if="ruleForm.sfssxjs === true">是</span>
            <span v-if="ruleForm.sfssxjs === false">否</span>
          </el-descriptions-item>
          <el-descriptions-item label="教职工当前状态" label-align="right" align="left" span="2">
            <span v-for="(item,index) in dqztData.list" :key="index">
              <span v-if="item.value === ruleForm.dqzt">{{item.name}}</span>
            </span>
          </el-descriptions-item>
          <el-descriptions-item label="是否已同步到SSO" label-align="right" align="left" span="2">
            <span v-if="ruleForm.sfytb === null">未同步</span>
            <span v-if="ruleForm.sfytb === false">与SSO数据不一致</span>
            <span v-if="ruleForm.sfytb === true">已同步</span>
          </el-descriptions-item>
          <el-descriptions-item label="" label-align="right" align="left" span="2"></el-descriptions-item>
          <el-descriptions-item label="同步失败原因" label-align="right" align="left" span="4">{{ruleForm.tbsbyy}}</el-descriptions-item>
        </el-descriptions>
      </el-col>
      <el-col :span="4">
        <el-image style="width: 100%; height: 200px;" :src="url + ruleForm.zp" fit="cover" >
          <template #error>
            <div class="image-slot" style="border: 1px solid #ebeef5;border-radius: 5px;">
              <el-icon :size="40"><UserFilled /></el-icon>
            </div>
          </template>
        </el-image>
      </el-col>
    </el-row>
      <el-descriptions title="教职工联系方式" :column="6" border>
        <el-descriptions-item label="手机号" label-align="right" align="center" width="80px" span="2">{{ruleForm.lxfs.yddh}}</el-descriptions-item>
        <el-descriptions-item label="固定电话" label-align="right" align="center" width="80px" span="2">{{ruleForm.lxfs.gddh}}</el-descriptions-item>
        <el-descriptions-item label="电子信箱" label-align="right" align="center" width="80px" span="2">{{ruleForm.lxfs.dzxx}}</el-descriptions-item>
      </el-descriptions>
      <div>
        <div class="el-descriptions__header">
          <div class="el-descriptions__title">教职工校内职务</div>
        </div>
          <el-table :data="ruleForm.xngwList" style="width: 100%" border height="100%">
            <el-table-column label="主要职务" prop="sfzygw" width="100" align="center" show-overflow-tooltip>
              <template #default="scope">
                <span v-if="scope.row.sfzygw === true">是</span>
                <span v-if="scope.row.sfzygw === false">否</span>
              </template>
            </el-table-column>
            <el-table-column label="所在机构" prop="jgmc" align="center" show-overflow-tooltip/>
            <el-table-column label="职务" prop="zwmc" align="center" show-overflow-tooltip/>
            <el-table-column label="起始年月" prop="gwqsny" width="112" align="center" show-overflow-tooltip/>
            <el-table-column label="终止年月" prop="gwjsny" width="112" align="center" show-overflow-tooltip/>
            <el-table-column label="在岗" prop="sfzg" width="100" align="center" show-overflow-tooltip>
              <template #default="scope">
                <span v-if="scope.row.sfzygw === true">是</span>
                <span v-if="scope.row.sfzygw === false">否</span>
              </template>
            </el-table-column>
          </el-table>
      </div>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { loadData } from '@/api/common.js'
import { getJzglt } from '@/utils/meiju'

const props = defineProps({
  row: { type: Object, required: false }
})
const url = ref(process.env.VUE_APP_BASE_API)
const ruleForm = ref({ lxfs: { yddh: '', gddh: '', dzxx: '' }, xngwList: [] })

// 加载 当前状态 下拉框
const dqztData = ref(getJzglt())
watch(
  () => props.row,
  () => {
    if (props.row) {
      url.value = process.env.VUE_APP_BASE_API
      loadData({
        url: '/api/v2/pdp/jiaozhigong/' + props.row.id,
        ruleForm,
        loadSuccess: function (res) {
          res.data.lxfs = res.data.lxfs || []
          res.data.xngwList = res.data.xngwList || []
        }
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
